<template>
  <div>
    <h1 class="light">Expired/Inactive Users Export</h1>
    <form class="form-inline" @submit.prevent="download">
      <div class="form-group">
        <label for="user_type">
          User Type <i class="fa fa-info-circle" id="user_type_tooltip" />
          <tooltip
            text="Enterprise means they're in a domain/part of a district customer. Consumer means they're individual sign ups."
            target="#user_type_tooltip"
          />
        </label>
        <select
          id="user_type"
          class="form-control"
          v-model="reportParams.user_type"
          :disabled="loading"
        >
          <option value="">Enterprise and Consumers</option>
          <option value="enterprise">Enterprise</option>
          <option value="consumer">Consumer</option>
        </select>
      </div>

      <div class="form-group">
        <label for="expired_before_date"> Expired Before </label>
        <input
          class="form-control"
          type="date"
          id="expired_before_date"
          v-model="reportParams.expired_before"
          :disabled="loading"
        >
      </div>

      <div class="form-group">
        <label for="last_active_before_date"> Last Active Before </label>
        <input
          class="form-control"
          type="date"
          id="last_active_before_date"
          v-model="reportParams.last_active_before"
          :disabled="loading"
        >
      </div>

      <div class="checkbox">
        <label for="apply_retention_policy">
          <input
            type="checkbox"
            id="apply_retention_policy"
            v-model="reportParams.apply_retention_policy"
            :disabled="loading"
          >
          Apply Retention Policy?
        </label>
      </div>
      <div class="form-group">
        <label>File Format</label>
        <label class="radio-inline">
          <input
            type="radio"
            name="file-format"
            id="file-format-csv"
            v-model="fileType"
            value="csv"
            :disabled="loading"
          >
          CSV
        </label>
        <label class="radio-inline">
          <input
            type="radio"
            name="file-format"
            id="file-format-xlsx"
            v-model="fileType"
            value="xlsx"
            :disabled="loading"
          >
          XLSX
        </label>
      </div>

      <button class="btn btn-primary" :disabled="!enableDownload || loading">
        <template
          v-if="loading"
        ><i class="fa fa-circle-o-notch fa-spin"/> Downloading...</template
        >
        <template v-else>Download</template>
      </button>
    </form>

    <alert
      v-if="error"
      type="danger"
      dismissible>{{ error }}</alert>
  </div>
</template>

<script>
import { Tooltip, Alert } from 'uiv'
import downloadBinToFile from '../scripts/file_download'

export default {
  name: 'ExpiredInactiveUsersExport',
  components: { Tooltip, Alert },
  data() {
    return {
      reportParams: {
        database: 'rds',
        user_type: '',
        expired_before: '',
        last_active_before: '',
        apply_retention_policy: true,
        default_consumer_retention_years: 3,
        default_enterprise_retention_years: 3,

        // bogus values - required by API
        sdate: '1000-01-01',
        edate: '1000-01-01'
      },
      fileType: 'csv',
      loading: false,
      error: null
    }
  },
  computed: {
    enableDownload() {
      return this.reportParams.expired_before && this.reportParams.last_active_before
    },
    yearAgoStr() {
      let today = new Date()
      return new Date(today.getFullYear() - 1, today.getMonth(), today.getDay())
        .toISOString()
        .split('T')[0]
    }
  },
  methods: {
    async download() {
      this.loading = true
      this.error = null
      try {
        let data = await this.$angularWorld.analyticsApi.getAnalyticsReport(
          'expired_inactive_users',
          this.reportParams,
          this.fileType
        )
        this.loading = false
        downloadBinToFile(data, 'expired_inactive_users.zip')
      } catch (err) {
        this.error = err
        this.loading = false
      }
    }
  },
  created() {
    this.reportParams.expired_before = this.yearAgoStr
    this.reportParams.last_active_before = this.yearAgoStr
  }
}
</script>

<style lang="less" scoped>
.form-inline {
  margin-top: 2em;
  display: flex;
  align-items: center;
  margin-bottom: 5em;
}
.form-group,
.checkbox {
  label:not([class='radio-inline']) {
    display: block;
  }
  margin-right: 1em;
}
.checkbox {
  flex: 1;
  padding-top: 1.75em;
}
</style>
